import { addUnits, addYears, monthsBetween, startOfMonth, unitsBetween, type Day } from '../core/calendar.ts';
import type { TimeBucket, Window } from '../types/domain.ts';

/** ForecastWindow(from: configuration, startDate: now): [start of now's month, + timeframeYears years), monthly. */
export function windowFromPlanConfiguration(timeframeYears: number, now: Day): Window {
  const start = startOfMonth(now);
  return { start, end: addYears(start, timeframeYears), interval: 'month' };
}

/** ForecastWindow.months: whole calendar months from start to end. */
export const windowMonths = (window: Window): number => monthsBetween(window.start, window.end);

/** ForecastWindow.intervalCount. */
export const intervalCount = (window: Window): number => unitsBetween(window.start, window.end, window.interval);

/** createTimeBuckets: bucket n is [start + n, start + n + 1) intervals, anchored at the window start (R6). */
export function timeBuckets(window: Window): readonly TimeBucket[] {
  const buckets: TimeBucket[] = [];
  for (let n = 0, start = window.start; start < window.end; n++) {
    const end = addUnits(window.start, window.interval, n + 1);
    buckets.push({ start, end });
    start = end;
  }
  return buckets;
}

/** PaymentCalculator.bucketIndex: the bucket whose [start, end) contains `date`, by binary search. */
export function bucketIndexContaining(buckets: readonly TimeBucket[], date: Day): number | null {
  let low = 0;
  let high = buckets.length;
  while (low < high) {
    const mid = (low + high) >> 1;
    if (buckets[mid]!.end <= date) low = mid + 1;
    else high = mid;
  }
  return low < buckets.length && buckets[low]!.start <= date ? low : null;
}
